import { Constants } from "appConstants";
import { baseConfig } from "config";
import CookieHelper from "./CookieHelper";

const ExternalAuthTokenHelper = {
	setExternalAuthToken(value: string) {
		CookieHelper.setCookies(Constants.EXTERNAL_ACCESS_TOKEN_COOKIE, value);
	},

	removeExternalAuthToken() {
		CookieHelper.removeCookie(Constants.EXTERNAL_ACCESS_TOKEN_COOKIE, {
			domain: baseConfig.baseURLDomain
		});
		CookieHelper.removeCookie(Constants.EXTERNAL_ACCESS_TOKEN_COOKIE);
	}
};

export default ExternalAuthTokenHelper;
